export default __webpack_public_path__ + "static/media/eventDetail.dc8562ce.png";